import { required, minLength, maxLength, regex } from 'react-admin';
import { Validators } from './types';

export const validateZipCode = regex(/^\d{5}$/, 'Must be a valid Zip Code');
export const validatePhoneNumber = regex(/^\d{10,11}$/, 'Must be 10 or 11 characters');
export const validateFirstName = [required(), minLength(1), maxLength(100)];
export const validateLastName = [required(), minLength(1), maxLength(100)];
export const validateMiddleName = [maxLength(1000)];

export const validateDateBounds =
  ({ disableFuture, disablePast, validate }: Validators.DateBoundsProps) =>
  (value: any, values: any, props: any) => {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return 'Invalid date';

    const now = new Date();

    if (disableFuture && date > now) return 'Date cannot be in the future';
    if (disablePast && date < now) return 'Date cannot be in the past';

    return validate?.(value, values, props);
  };
